<template>
  <div>
    <v-alert :value="erroreAllineamento" dismissible prominent dense type="warning">Attenzione! I numeratori in cloud non risultano allineati! Aprire la pagina Home per riallineare.</v-alert>    
    <v-data-table
      v-model="selected"
      :show-select="totaleDocumenti > 0"
      item-key="_id"
      :headers="headers"
      :items="documenti"
      :options.sync="options"
      :server-items-length="totaleDocumenti"
      :loading="loading"
      class="elevation-1"
      @item-expanded="itemExpanded"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25, 50, 100]
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :show-expand="true"
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ title || 'Documenti' }}</v-toolbar-title>
<!--    <v-divider class="mx-4" inset vertical></v-divider> -->
        <v-spacer></v-spacer>
        <v-btn v-if="!hideRiepilogativa" :disabled="erroreAllineamento" color="success" class="mb-2 mr-5" @click="onCreazioniMultiple">Fatturazione riepilogativa</v-btn>
        <v-btn v-if="!hideRiepilogativa" :disabled="erroreAllineamento" color="primary" class="mb-2" @click="onNuovoDocumento">Nuovo Documento</v-btn>
        <v-btn v-if="hideRiepilogativa" :disabled="erroreAllineamento" color="success" class="mb-2 mr-5" @click="onNuovoPreventivo">Nuovo Preventivo</v-btn>
        <v-btn v-if="hideRiepilogativa" :disabled="erroreAllineamento" color="primary" class="mb-2" @click="onNuovoOrdine">Nuovo Ordine</v-btn>        
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5">Confermi cancellazione documento?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
              <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <dialog-errore :show="dialogErrore" :title="errorTitle" :message="errorMessage" @dialogConfirm="dialogErrore = false"/>
        <dialog-stampa
          :show="dialogStampa"
          title="Stampa Etichette"
          confirmText="Stampa"
          cancelText="Annulla"
          :totaleEtichette="totaleEtichette"
          :isStampaEtichette="true"
          :isModuloA4="isModuloA4"
          @dialog-print="onDialogPrint"
          @dialog-cancel="onDialogCancel"
        />
      </v-toolbar>
      <filtri :filtraTipiDocumento="filtroTipiDocumento" @ricerca="onRicerca"/>

    </template>
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | dateTime }}
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon v-if="abilitaCancellazione" small class="mr-2" @click="deleteItemWithPassword(item)" title="Cancella documento e movimenti collegati" color="red">mdi-delete</v-icon>
      <v-icon small class="mr-2" @click="editItem(item, xmlGenerato(item) && !erroreTrasmissione(item))" :title="xmlGenerato(item) && !erroreTrasmissione(item) ? 'Dettaglio del documento' : 'Modifica il movimento'">{{ xmlGenerato(item) && !erroreTrasmissione(item) ? 'mdi-archive-eye-outline' : 'mdi-pencil' }}</v-icon>
      <v-icon small class="mr-2" @click="stampaDocumento(item)" :title="giaStampato(item) ? 'Il documento è stato già stampato' : 'Stampa Documento'" :color="giaStampato(item) ? 'green' : ''">mdi-printer-outline</v-icon>
      <v-icon v-if="isFattura(item)" small class="mr-2" @click="generaXml(item)" :title="xmlGenerato(item) ? erroreTrasmissione(item) ? 'XML già generato ma con errori' : 'XML già generato' : 'Genera XML fattura'" :color="xmlGenerato(item) ? erroreTrasmissione(item) ? 'red' : 'green' : ''">mdi-xml</v-icon>      <v-icon small class="mr-2" v-if="abilitaInvioEmail(item)" @click="emailDocumento(item)" :title="giaInviata(item) ? 'Email già inviata' : 'Invia email'" :color="giaInviata(item) ? 'green' : ''">mdi-email-outline</v-icon>
      <v-menu v-if="destinazioni(item).length > 0">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-icon small class="mr-2" title="Trasforma Ordine" v-bind="attrs" v-on="{ ...menu }">mdi-content-duplicate</v-icon>
        </template>
        <v-list>
          <template v-for="(m, index) in destinazioni(item)">
            <v-list-item :key="index">
              <v-list-item-title><v-btn text @click="trasformaIn(m, item)">{{m.descrizione}}</v-btn></v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
      
    </template>
    <template v-slot:no-data>
      Nessun dato disponibile
      <!-- <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn> -->
    </template>
    <template v-slot:[`item.data-table-expand`]="{ item, expand, isExpanded }">
      <td v-if="destinazioni(item).length === 0" class="text-start">
        <v-btn icon
              @click="expand(!isExpanded)" 
              class="v-data-table__expand-icon"
              :class="{'v-data-table__expand-icon--active' : isExpanded}">
          <v-icon>mdi-chevron-down</v-icon>
        </v-btn>
      </td>
    </template>    
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length" v-if="item.stato && ['convertito', 'daVerificare', 'stornato'].includes(item.stato.codice)" class="td-documento-selected">
        <v-tabs dense v-model="tab">
          <v-tab>Documenti collegati{{item.name}}</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="rc in triggerDettaglio && documentoCollegato[item._id]" :key="rc._id">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Tipo</th>
                    <th class="text-left">Numero</th>
                    <th class="text-left">Data</th>
                    <th class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ rc.tipoDocumento.descrizione }}</td>
                    <td>{{ rc._id }}</td>
                    <td>{{ rc.data | date }}</td>
                    <td><a :href="'/v-documenti?num=' + rc._id">Val al documento</a></td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-tab-item>
        </v-tabs-items>
      </td>
    </template>
    </v-data-table>
    <speed-dial @comando="onSpeedDialogComando"/>
    <creazioni-multiple :showDialog="showDialogMultiple"/>
    <dettaglio-fattura :showDialog="showDettaglioFattura" :idDocumento="idDocumento" :trigger="triggerUpdate"/>
    <edit-documento :showDialog="showEditDocumento" :idDocumento="idDocumento" :filtraTipiDocumento="filtraTipiDocumento" :coloreOrdine="coloreOrdine" :readOnly="readOnly" :trigger="triggerUpdate" :forzaDocumento="forzaDocumento" @refresh="getDataFromApi" @salvataggioAvvenuto="salvataggioAvvenuto"/>  
  </div>
</template>

<script>
  import { downloadXml, slugify, downloadZip, getAnnoRiferimento } from '@/components/helpers.js'
  import moment from 'moment'
  import xml7 from '@/services/xml7Service.js'
  import JSZip from 'jszip'
  import { dynamicSortMultiple } from '@/components/helpers.js'
  import DialogErrore from '@/components/dialogErrore'
  import DialogStampa from '@/components/dialogStampa'
  import SpeedDial from './speedDial.vue'
  import Filtri from './testate_filtri'
  import DettaglioFattura from './fatture/dettaglioFattura'
  import CreazioniMultiple from './creazioniMultiple'
  import EditDocumento from './edit/editDocumento'
  import configurazioni from '@/services/configurazioniService.js'
  import prodotti from '@/services/prodottiService.js'
  import clienti from '@/services/clientiService.js'
  import documenti from '@/services/documentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import etichetteService from '@/services/etichetteService.js'
  import reporting from '@/services/reportingService.js'
  import emailService from '@/services/emailService.js'
  import elettronica from '@/services/elettronicaService.js'
  import { printed } from '@/helpers/printed.js'
  import { emailed, buildDestinatario, buildOggetto } from '@/helpers/emailed.js'
  const labelsPath = window.appConfig.VUE_APP_MOL_S_LABELS

  export default {
    components: {
      DialogErrore,
      Filtri,
      SpeedDial,
      DettaglioFattura,
      DialogStampa,
      CreazioniMultiple,
      EditDocumento
      // Recapiti
    },
    props: {
      filtraTipiDocumento: Array,
      title: String,
      hideRiepilogativa: Boolean,
      coloreOrdine: Boolean
    },
    data () {
      return {
        totaleDocumenti: 0,
        documenti: [],
        selected: [],
        loading: true,
        options: {
          itemsPerPage: 25
        },
        headers: [
          { text: 'Tipo', value: 'tipoDocumento.descrizione', align: 'start'},
          { text: 'Numero', value: '_id'},
          { text: 'Data', value: 'data' },
          { text: 'Nominativo', value: 'd_nominativo' },
          { text: 'Stato', value: 'stato.descrizione' },
          { text: 'Stato XML', value: 'tipoDocumento.xml.status' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false,
        // salta: 0,
        tipoStampa: '',
        report: '',
        isModuloA4: false,
        errorTitle: 'Errore aggiornamento Documento',
        errorMessage: '',
        showDialogMultiple: false,
        showDettaglioFattura: false,
        triggerUpdate: 1,
        triggerDettaglio: 1,
        idDocumento: null,
        showEditDocumento: false,
        forzaDocumento: '',
        readOnly: false,
        statoConvertito: { codice: 'convertito', descrizione: 'convertito' },
        statoAnnullato: { codice: 'annullato', descrizione: 'annullato' },
        documentoCollegato: {},
        abilitaCancellazione: false,
        codiceCancellazione: '0000',
        // abilitaInvioEmail: false,
        infoEmail: null,
        infoFatturazione: null,
        erroreAllineamento: false
/*         tipoDestinatario: 'pec',
        tipoCc: '' */
      }
    },
    async created() {
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
      await this.getDefaultItem()
      const impostazioni = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      if (_.get(impostazioni, 'cancellazioni.documentiCliente')) {
        this.abilitaCancellazione = true
      }
      const email = _.get(impostazioni, 'email')
      this.infoEmail = email
      const info = _.get(impostazioni, 'fatturazione')
      this.infoFatturazione = info
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo Documento' : 'Modifica Documento'
      },
      documentiSaved() {
        return this.$store.getters['documenti/saved']
      },
      testataAperta() {
        return this.$store.getters['documenti/page'] === 'testata'
      },
      refreshList() {
        // console.log('refreshList')
        return this.$store.getters['documenti/refreshTestata']
      },
      documentiSorted() {
        const els = this.documenti
        const elSorted = els.sort(dynamicSortMultiple('-_id'))
        return elSorted
      },
      totaleEtichette() {
        const elSel = this.selected
        if (elSel.length > 0) {
          const totaleAnagrafica = _.sum(elSel.map(x => x.qtaAnagrafica))
          const totaleDocumenti = _.sum(elSel.map(x => x.qtaDocumenti))
          return { totaleAnagrafica, totaleDocumenti }
        } else {
          return { totaleAnagrafica: 0, totaleDocumenti: 0 }
        }
      },
      filtroTipiDocumento() {
        return this.filtraTipiDocumento && this.filtraTipiDocumento.length > 0 ? this.filtraTipiDocumento.map(x => x.tipoDocumento) : []
      }
    },
    watch: {
      options: {
        async handler () {
          console.log('handler')
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async documentiSaved(value) {
        if (value && this.testataAperta) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          this.options.page = 1
          await this.getDataFromApi()
          this.$store.commit('documenti/CLEAR_REFRESH', 'testata')
        }
      },
      async filtraTipiDocumento() {
        await this.getDataFromApi()
      }
    },
    /*     async created() {
      await this.getDefaultItem()
    }, */
    async mounted () {
      const verificaNumeratori = await configurazioni.verificaAllineamentoNumeratori()
      if (!['ok', '---'].includes(verificaNumeratori.status)) {
        this.erroreAllineamento = true
        const query = { ...this.$route.query }
      if (query && query.idedit) {
        let numero = decodeURI(query.idedit)
        await this.$nextTick()
        this.options.page = 1
        this.filtri = {
          numero: numero
        }        
        await this.getDataFromApi()
        const item = this.documenti.find(x => x._id === numero)
        if (item) {
          this.editItem(item)
        }
      }
    }
    },
    methods: {
      abilitaInvioEmail(item, verificaAutomatico) {
        if (!this.infoEmail) return false
        const info = this.infoEmail.find(x => x.tipiDocumento.includes(item.tipoDocumento.tipoDocumento))
        if (!verificaAutomatico) {
          return info ? info.abilitaInvioEmail : false
        } else {
          return info ? info.abilitaInvioEmail && info.invioAutomatico : false
        }
      },
      abilitaInvioSDI(item) {
        if (!this.infoFatturazione) return false
        if (this.infoFatturazione.tipiDocumento.includes(item.tipoDocumento.tipoDocumento)) {
          return this.infoFatturazione ? this.infoFatturazione.invioAutomaticoSDI : false
        } else {
          return false
        }
      },      
      async itemExpanded({ item, value }) {
        if (value) {
          await this.aggiornaCollegato(item)
        }
      },
      deleteItemWithPassword(item) {
        if (prompt('inserire codice per cancellazione') === this.codiceCancellazione) {
          this.deleteItem(item)
        }
      },
      deleteItem (item) {
        this.editedIndex = this.documenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        this.documenti.splice(this.editedIndex, 1)
        const doc = this.editedItem
        await magazzino.cancellaPerRiferimento('documento', doc._id, doc.data)        
        await documenti.cancellaDocumento(doc._id)        
        this.closeDelete()
      },         
      async aggiornaCollegato(item) {
        const collegamento = _.get(item, 'trasforma.destinazione', '') || _.get(item, 'trasforma.sorgente', '') 
        if (collegamento) {
          const collegato = await documenti.getDocumento(collegamento)
          this.documentoCollegato[item._id] = [collegato]
          this.triggerDettaglio++
        }
      },
      destinazioni(item) {
        // in base al tipo documento ed al suo stato, determino quali possono essere i documenti di destinazione
        const destinazioni = []
        switch (item.tipoDocumento.tipoDocumento) {
          case "ordineCliente":
            if (!item.stato || ['aperto', 'parziale', 'daVerificare'].includes(item.stato.codice)) {
              destinazioni.push({ codice: 'ddt', descrizione: 'Crea DDT cliente' })
              destinazioni.push({ codice: 'ddtTrasferimento', descrizione: 'Crea DDT di Trasferimento' })
              destinazioni.push({ codice: 'fatturaImmediata', descrizione: 'Crea Fattura Immediata cliente' })
              destinazioni.push({ codice: 'annullato', descrizione: 'Ordine annullato' })
            }
            break
          case "preventivoCliente":
            if (!item.stato || ['aperto', 'parziale'].includes(item.stato.codice)) {
              destinazioni.push({ codice: 'ordineClienteWeb', descrizione: 'Crea Ordine cliente' })
            }
            break            
          default:
            break
        }
        return destinazioni
      },      
      isFattura(item) {
        return item.tipoDocumento.xml
      },
      async onCreazioniMultiple() {
        this.showDialogMultiple = true
        await this.$nextTick()
        this.showDialogMultiple = false
      },
      async getDefaultItem() {
        this.defaultItem = await documenti.getModello('xxx')
        this.defaultItem.data = new Date()
      },
      async stampaDocumento(item) {
        try {
          const result = await reporting.stampaDocumento(this.$router, item, true, true)
          if (result && result.error) {
            console.log(result.error)
          } else {
            await printed(item._id)
            await this.getDataFromApi()
          }
        } catch {}
      },
      async emailDocumento(item) {
        try {
          let infoEmail = this.infoEmail.find(x => x.tipiDocumento.includes(item.tipoDocumento.tipoDocumento))
          if (!infoEmail) return
          const tipoDestinatario = infoEmail.emailInvio || 'pec'
          const tipoCc = infoEmail.emailCc || ''  
          
          const cliente = await clienti.getCliente(item.anagrafica.cliente.codice)
          const destinatario = buildDestinatario(cliente, tipoDestinatario)
          if (destinatario.length === 0) {
            this.errorTitle = 'Invio email non possible !'
            this.errorMessage = 'Non è stata trovata una email valida per il destinatario.<br />Valore cercato: ' + tipoDestinatario
            this.dialogErrore = true            
            return
          }
          const result = await reporting.stampaDocumento(this.$router, item, true, true, null, 'base64')
          if (result && result.error) {
            this.errorTitle = 'Invio email non possible !'
            this.errorMessage = 'Errore nella stampa del documento'
            this.dialogErrore = true            
            return
          } else {
            const copiaCarbone = buildDestinatario(cliente, tipoCc)
            const allegati = [{
              content: result,
              filename: 'documento.pdf',
              type: 'application/pdf',
              disposition: 'attachment'
            }]
            infoEmail.oggetto = buildOggetto(item, infoEmail.oggetto)
            if (await emailService.inviaEmail(destinatario, copiaCarbone, infoEmail, allegati)) {
              await emailed(item._id, destinatario, copiaCarbone)
              await this.getDataFromApi()
            }
          }
        } catch(err) {
          console.log('errore', err)
        }
      },
 /*      buildDestinatario(item, destinatario) {
        let to = []
        const tdd = destinatario.split(',')
        for (let td of tdd) {
          let nome = ''
          let email = ''
          let sede = null
          switch(td) {
            case 'fatture':
              email = _.get(item, 'fatturazione.emailInvio') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (email) to.push({ nome, email })
              break
            case 'pec':
              email = _.get(item, 'fatturazione.pec') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (email) to.push({ nome, email })
              break
            case 'sede':
              sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
              if (sede) {
                email = sede.email || ''
                nome = email  // TODO: Prevedere una Descrizione del recapito
                if (email) to.push({ nome, email })
              }
              break
            case 'recapiti':
              break
            case 'primoCompilato':
              email = _.get(item, 'fatturazione.emailInvio') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (!email) {
                email = _.get(item, 'fatturazione.pec') || ''
                nome = _.get(item, 'ragioneSociale') || email
              }
              if (!email) {
                sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
                if (sede) {
                  email = sede.email || ''
                  nome = email 
                }
              }
              if (email) to.push({ nome, email })
              break
            case 'tutti':
              email = _.get(item, 'fatturazione.emailInvio') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (email) to.push({ nome, email })
              email = _.get(item, 'fatturazione.pec') || ''
              nome = _.get(item, 'ragioneSociale') || email
              if (email) to.push({ nome, email })
              sede = item.recapiti ? item.recapiti.find(x => x.tipo && x.tipo.codice === 'principale') : null
              if (sede) {
                email = sede.email || ''
                nome = email
                if (email) to.push({ nome, email })
              }             
              break
            default:
              break
          }   
        }
        return to
      }, */
      async trasformaIn(destinazione, item) {
        const documento = await documenti.getDocumento(item._id)
        if (documento) {
          if (destinazione.codice === 'annullato') {
            documento.stato = this.statoAnnullato
            await documenti.aggiornaDocumento(documento)
          } else {
            const elenco = await configurazioni.getConfigurazione('documenti_parametri', 'tipiDocumento')
            const tipoDestinazione = elenco.find(x => x.codice === destinazione.codice)
            let newDoc = await documenti.trasformaDocumento(documento, tipoDestinazione, this.statoConvertito)
          }
          this.options.page = 1
          await this.getDataFromApi() 
        }
      },
      async generaXml(item) {
        // if (this.xmlGenerato(item)) return  // Se già creato, mantiene il numero 

        let documento = await documenti.getDocumento(item._id)
        if (documento) {
          const { fattura, nomeFile, xml7File } = await xml7.creaXml7Fattura(documento)
/*           _.set(documento, 'tipoDocumento.xml.fileGenerato', true)
          _.set(documento, 'tipoDocumento.xml.nomeFile', nomeFile)
          await documenti.aggiornaDocumento(documento) */
          downloadXml(document, nomeFile, xml7File)
          await this.getDataFromApi()
        }
      },
      xmlGenerato(item) {
        // TODO: Togliere. Solo per errore vecchia procedura su Danitec (21.08.2022)
        const generato = _.get(item, 'tipoDocumento.xml.fileGenerato', false)
        return typeof generato === 'string' ? true : generato
      },
      erroreTrasmissione(item) {
        return this.xmlTrasferitoConErrori(item)
        // return _.get(item, 'tipoDocumento.xml.status', '') === 'Errore elaborazione'
      },
      xmlTrasferitoConErrori(item) {
        const trasmissioni = _.get(item, 'tipoDocumento.xml.trasmissioni', [])
        let errori = !this.xmlTrasferito(item) && trasmissioni.length > 0 || _.get(item, 'tipoDocumento.xml.status', '') === 'Scartata'
        if (trasmissioni.length > 0) {
          let ordered = [ ...trasmissioni ]
          ordered = ordered.sort(dynamicSortMultiple('-data'))
          const lastInfo = ordered[0]
          errori = errori || (lastInfo.errorCode !== '0000')
        }
        return errori
      },   
      giaStampato(item) {
        const pr = _.get(item, 'editInfo.printed')
        return pr && pr.length > 0 
      },
      giaInviata(item) {
        const em = _.get(item, 'editInfo.emailed')
        return em && em.length > 0 
      },
      async onRicerca(filtri) {
        this.filtri = filtri
        this.options.page = 1
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          /*
            Versione per dettaglio riga
            const data = await magazzino.getFilteredMovements(this.filtri, this.options)
            this.documentiRaw = data && data.total_rows > 0 ? data.rows : [] // TODO: valida per la versione modificata. Da adeguare
          */
        if (this.filtraTipiDocumento && this.filtraTipiDocumento.length > 0) {
          if (!this.filtri.tipoDocumento || this.filtri.tipoDocumento.length === 0) {
            this.filtri.tipoDocumento = this.filtraTipiDocumento.map(x => x.tipoDocumento)
          }
        }
          const data = await documenti.getFilteredDocumentHeaders(this.filtri, this.options)
          // this.documentiRaw = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          this.documentiRaw = data && data.total_rows > 0 ? data.rows : []
          this.documentiRaw = this.documentiRaw.filter(x => x.tipoDocumento) // Elimina documenti contabili
          let docs = this.datiVisualizzazione(this.documentiRaw)
          if (this.filtroTipiDocumento && this.filtroTipiDocumento.length > 0) {
            docs = docs.filter(x => this.filtroTipiDocumento.includes(x.tipoDocumento.tipoDocumento))
          }
          this.documenti = docs

          // this.documenti = data && data.total_rows > 0 ? data.rows : []
          this.totaleDocumenti = data.total_rows
        } catch(err) {
          this.documenti = []
          this.totaleDocumenti = 0
        } finally {
          this.loading = false
        }
      },
      async onNuovoDocumento() {
        // this.$router.push('v-documenti-edit')
        prodotti.clearCache()
        this.idDocumento = null
        this.showEditDocumento = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDocumento = false
      },
      async onNuovoPreventivo() {
        prodotti.clearCache()
        _.set(this.locDocumento, 'tipoDocumento.codice', 'preventivoCliente')
        this.nuovoDocumento = true
        this.forzaDocumento = 'preventivoCliente'
        this.idDocumento = null
        this.showEditDocumento = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDocumento = false
      },
      async onNuovoOrdine() {
        prodotti.clearCache()
        _.set(this.locDocumento, 'tipoDocumento.codice', 'ordineCliente')
        this.nuovoDocumento = true
        this.forzaDocumento = 'ordineCliente'
        this.idDocumento = null
        this.showEditDocumento = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDocumento = false
      },        
      async dettaglioItem (item) {
        /*         this.editedIndex = this.documenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('documenti/SET_CHIAVE', this.editedItem)
        this.$emit('apriDettaglio', this.editedItem) */

        this.idDocumento = item._id
        this.showDettaglioFattura = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showDettaglioFattura = false

      },
      async editItem (item, readonly) {
        this.idDocumento = item._id
        this.readOnly = readonly
        this.showEditDocumento = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDocumento = false        
/*         this.editedIndex = this.documenti.indexOf(item)
        this.editedItem = await documenti.getDocumento(item._id)
        await this.completaAppoggio()
        this.$store.commit('documenti/SET_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      async completaAppoggio() {
        let itm = this.editedItem
        _.set(itm,'appoggio.clienteVisibile', itm.tipoDocumento.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoDocumento.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoDocumento.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoDocumento.infoPagamento)
        _.set(itm,'appoggio.tipoDocumento', itm.tipoDocumento)
        // const clienteId =  _.get(itm.anagrafica, 'cliente.codice', '') || _.get(itm.anagrafica, 'fornitore.codice', '')
        // const clifor = await clienti.getCliente(clienteId)
        const clifor = _.get(itm.anagrafica, 'cliente', '') || _.get(itm.anagrafica, 'fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      },      
      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async save () {
        this.$store.commit('documenti/CLEAR_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['documenti/documento']
        if (this.editedIndex > -1) {
          // verificare
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteModifica = this.$store.getters.utente
          Object.assign(this.documenti[this.editedIndex], this.editedItem)
          if (!await documenti.aggiornaDocumento(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          const numeratore = this.editedItem.tipoDocumento.numeratore
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteCreazione = this.$store.getters.utente
          // sarebbe meglio mettere il numeratore su documenti, ma finchè non c'è molecular fa troppi giri ....
          const annoRiferimento = getAnnoRiferimento(this.editedItem.data) // this.editedItem.data.getFullYear()
          console.log('annoRiferimento', annoRiferimento, this.editedItem.data)
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          this.editedItem.codice = numero
          this.editedItem._id = numero
          this.documenti.push(this.editedItem)
          if (!await documenti.creaDocumento(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        }
        this.editedItem = null
        this.editedIndex = -1
        this.close()
        // va fatto il refresh della lista per prendere gli aggiornamenti
        await this.getDataFromApi()
      },
      async salvataggioAvvenuto(item) {
        if (this.abilitaInvioSDI(item)) {
          if (this.xmlTrasferito(item)) return
          const xmlResult = await xml7.creaXml7Multipli([item._id])
          if (xmlResult.length > 0) {
            const ft = xmlResult[0]
            const result = await elettronica.trasferisciXml(item._id, ft.file, ft.link)
          }
        }
        if (this.abilitaInvioEmail(item, true)) {
          if (!this.giaInviata(item)) {
            await this.emailDocumento(item)
          }
        }        
      },
      xmlTrasferito(item) {
        return _.get(item, 'tipoDocumento.xml.fileTrasferito', false)
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editItem (item)
/*         this.editedIndex = this.documenti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('documenti/SET_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      datiVisualizzazione(documenti) {
        const elaborati = documenti.map(el => {
          const d_nominativo = el.anagrafica && ((el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)) || ''
          const nominativo = el.anagrafica && ((el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)) || ''
          return { ...el, c_nominativo: nominativo, d_nominativo: d_nominativo }
        })
        return elaborati
      },
      deleteDatiVisualizzazione(documento) {
        let locDocumento = {...documento}
        delete locDocumento.c_nominativo
        delete locDocumento.d_nominativo
        delete locDocumento.appoggio
        return locDocumento
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'stampa-etichette':
            const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
/*             this.tipoStampa = impostazioni.tipo
            this.report = impostazioni.report
            this.isModuloA4 = impostazioni.tipo === 'pdf' */
            this.dialogStampa = true
            break
          case 'stampa-documenti':
            if (this.selected.length > 0) {
              var zip = new JSZip()
              for (let item of this.selected) {
                try {
                  // TODO: Su moleculer fare lato server vedi: const zlib = require('zlib');
                  const pdfFile = await reporting.stampaDocumento(this.$router, item, true, true, false, 'base64')
                  let nomeFile = slugify(item._id) + '.pdf'
                  zip.file(nomeFile, pdfFile, { base64: true });
                  if (pdfFile) {
                    await printed(item._id)
                  }               
                } catch (error) {
                  console.log(error)
                }
              }
              const content = await zip.generateAsync({ type: 'base64' })
              downloadZip(document, 'Stampe.zip', content, true) 
              await this.getDataFromApi()
            }
            break
          default:
            break
        }
      },
      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta, tipoStampa, report) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        // this.salta = salta
        this.dialogStampa = false
        const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'movimento'
        const documenti = this.selected
        for (let mm of documenti) {
          const filtriAggiuntivi = [{
            applicazione: 'movimenti',
            chiave: 'riferimento.id',
            testo: _.get(mm, '_id', '')            
/*             applicazione: 'documenti',
            chiave: 'riferimento.id',
            testo: mm.riferimento.id */
          }]
          const parametri = {
            articoli: true,
            filtri: filtriAggiuntivi,
            gruppi: [],
            tipoQuantita
          }
          const filtro = {
            start: moment(mm.data).startOf('day').format('YYYYMMDD'),
            end: moment(mm.data).endOf('day').format('YYYYMMDD')
          }
          const filtroElementi = { filtro, parametri }
          const src = `${labelsPath}/${tipoStampa}/${report}?elm=${btoa(JSON.stringify(filtroElementi))}${salta ? '&sk=' + salta : ''}${tipoQuantita ? '&tpq=' + tipoQuantita : ''}`
          const printResult = await etichetteService.stampaDiretta(tipoStampa, src)
          if (printResult.status && printResult.status === 'error') {
            this.errorTitle = ' Errore stampa etichette'
            this.errorMessage = printResult.error
            this.dialogErrore = true
          }
        }
        this.annullaSelezione()
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

  td.td-documento-selected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
